import get from 'lodash/get'
import styles from '../AdventureCardDsl.module.scss'
import { connect } from 'react-redux'
import cx from 'classnames'
import { target } from '../../../utils'

import PropTypes from 'prop-types'
import { defineMessage, useIntl } from 'react-intl'

function CardDsl({
  adventure,
  activityPage,
  isHighlighted,
  children,
}) {
  const { formatMessage } = useIntl()
  const picture = get(adventure, 'picture["244x122"]', '')

  return (
    <a
      href={activityPage}
      className={cx(styles.adventureCard, {
        [styles.highlighted]: isHighlighted,
      })}
      target={target}
    >
      <div className={styles.imgWrapper}>
        <img
          src={picture}
          className={styles.img}
          alt={formatMessage(defineMessage({ defaultMessage: 'adventure card image' }))}
        />
      </div>
      <div className={styles.info}>{children}</div>
    </a>
  )
}

export default connect((state) => ({
  selectedCurrency: state.selectedCurrency,
}))(CardDsl)

CardDsl.propTypes = {
  adventure: PropTypes.object,
  activityPage: PropTypes.string,
  isHighlighted: PropTypes.bool,
  children: PropTypes.node,
}
